import {
    AfterViewInit, Component, EventEmitter, Input,
    Output
} from '@angular/core';
import { AddressModel } from '../../shared/models/address.model';
import { NgForm } from '@angular/forms';
import { ViaCepAddressModel } from '../../shared/models/via-cep-address.model';
import cep, { CEP } from 'cep-promise';

@Component({
    'selector': 'payment-address-form',
    'templateUrl': './payment.address-form.component.html'
})
export class PaymentAddressFormComponent implements
    AfterViewInit {
    public model: AddressModel = new AddressModel;
    public addressFoundAtApi = false;
    public addressFound: ViaCepAddressModel;
    @Input() canBeSubmitted = true;
    @Input() submitButtonContent = '';
    @Input() creatingAddressZipCode = '';
    @Input() addressToUpdate: AddressModel = null;
    @Input() errors: any = {};
    @Output() submitted: EventEmitter<AddressModel> = new EventEmitter();
    @Output() findingZipCode: EventEmitter<string> = new EventEmitter();
    @Output() foundZipCode: EventEmitter<string> = new EventEmitter();
    @Output() notFoundZipCode: EventEmitter<string> = new EventEmitter();
    @Output() filled: EventEmitter<AddressModel> = new EventEmitter();
    @Output() unfilled: EventEmitter<null> = new EventEmitter();
    public extraFieldsState = true;
    private extraFieldsData = {};

    ngAfterViewInit() {
        if (this.addressToUpdateIsDefined()) {
            this.populateModel(this.addressToUpdate);
        }
        if (this.creatingAddressZipCodeIsDefined()) {
            this.model.zip_code = this.creatingAddressZipCode.replace(/\D/g, '');
            this.findZipCode();
        }
    }

    /**
     * This is responsible for decide if model must be created or updated
     * and call respective services.
     **/
    public save(form: NgForm): void {
        if (form.valid && this.extraFieldsState) {
            this.prepareExtraFieldData();
            this.submitted.emit(this.model);
        }
    }
    /**
     * Search address at ViaCep API using zip code and fill fields.
     **/
    public findZipCode() {
        const zipCode = this.model.zip_code.replace(/\D/g, '');
        if (zipCode.length === 8) {
            this.findingZipCode.emit(zipCode);
            cep(zipCode).then((result: CEP) => {
                this.addressFound = result;
                this.model.zip_code = zipCode;
                this.model.address = this.addressFound.street || '';
                this.model.city = this.addressFound.city || '';
                this.model.state = this.addressFound.state || '';
                this.model.neighborhood = this.addressFound.neighborhood || '';

                this.addressFoundAtApi = true;
                this.foundZipCode.emit(zipCode);
            }).catch(() => {
                this.model.zip_code = zipCode;
                this.model.address = '';
                this.model.city = '';
                this.model.state = '';
                this.model.neighborhood = '';

                this.addressFoundAtApi = false;
                this.notFoundZipCode.emit(zipCode);
            });
        } else if (zipCode.length < 8 && this.addressFoundAtApi) {
            this.addressFoundAtApi = false;
        }
    }
    /**
     * If form is valid, trigger filled event.
     **/
    public checkFulfilment(addressForm: NgForm) {
        if (addressForm.valid) {
            this.prepareExtraFieldData();
            this.filled.emit(this.model);
        } else {
            this.unfilled.emit(null);
        }
    }
    /**
     * This test if street was found at ViaCep API.
     **/
    public addressWasFound(): boolean {
        return (
            this.addressFound &&
            this.addressFound.street !== undefined &&
            this.addressFound.street !== null &&
            this.addressFound.street !== ''
        );
    }
    /**
     * This test if city was found at ViaCep API.
     **/
    public cityWasFound(): boolean {
        return this.addressFound && this.addressFound.city !== undefined && this.addressFound.city !== '';
    }
    /**
     * This test if state was found at ViaCep API.
     **/
    public stateWasFound(): boolean {
        return this.addressFound && this.addressFound.state !== undefined && this.addressFound.state !== '';
    }
    /**
     * This test if neighborhood was found at ViaCep API.
     **/
    public neighborhoodWasFound(): boolean {
        return (
            this.addressFound &&
            this.addressFound.neighborhood !== undefined &&
            this.addressFound.neighborhood !== null &&
            this.addressFound.neighborhood !== ''
        );
    }

    /**
     * Check if addressToUpdate property is defined and not null.
     **/
    private addressToUpdateIsDefined() {
        return this.addressToUpdate !== null;
    }
    /**
     * Check if creatingAddressZipCode property is defined and has value.
     **/
    private creatingAddressZipCodeIsDefined() {
        return this.creatingAddressZipCode !== undefined
            && this.creatingAddressZipCode !== '';
    }
    /**
     * This uses an address instance to populate 'model' property.
     **/
    private populateModel(address: AddressModel) {
        this.model.id = address.id;
        this.model.address = address.address;
        this.model.number = address.number;
        this.model.zip_code = address.zip_code.replace(/\D/g, '');
        this.model.complement = address.complement;
        this.model.neighborhood = address.neighborhood;
        this.model.city = address.city;
        this.model.state = address.state;
        if (address.city_id !== null) {
            this.model.city_id = address.city_id;
        }
    }
    /**
     * Set extra field data into model extra fields index and unset from
     * model if empty.
     **/
    private prepareExtraFieldData() {
        this.model.extra_fields = this.extraFieldsData;
        if (Object.keys(this.model.extra_fields).length === 0) {
            delete this.model.extra_fields;
        }
    }

    /**
     * Set extraFieldsState property when changed
     * */
    public onExtraFieldsChange(isValid: boolean): void {
        this.extraFieldsState = isValid;
    }
    /**
     * Sets extra fields object to be sent for request
     * */
    public setExtraFieldsData(data: Object): void {
        this.extraFieldsData = data;
    }

    /**
     * Load zip code mask pattern.
     * */
    public loadZipCodeMask() {
        return [
            /\d/, /\d/, /\d/, /\d/, /\d/, '-',
            /\d/, /\d/, /\d/
        ];
    }
    /**
     * Load state mask pattern.
     * */
    public loadStateMask() {
        return [/[A-Z]/, /[A-Z]/];
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/payment/address-form/payment.address-form.component.ts